import _regeneratorRuntime from "/home/deploy/fe/v9/tigo-home-activator-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/deploy/fe/v9/tigo-home-activator-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
export var encoder = new TextEncoder();
export var decoder = new TextDecoder();
var MAX_INT32 = Math.pow(2, 32);
export function concat() {
  for (var _len = arguments.length, buffers = new Array(_len), _key = 0; _key < _len; _key++) {
    buffers[_key] = arguments[_key];
  }

  var size = buffers.reduce(function (acc, _ref) {
    var length = _ref.length;
    return acc + length;
  }, 0);
  var buf = new Uint8Array(size);
  var i = 0;
  buffers.forEach(function (buffer) {
    buf.set(buffer, i);
    i += buffer.length;
  });
  return buf;
}
export function p2s(alg, p2sInput) {
  return concat(encoder.encode(alg), new Uint8Array([0]), p2sInput);
}

function writeUInt32BE(buf, value, offset) {
  if (value < 0 || value >= MAX_INT32) {
    throw new RangeError("value must be >= 0 and <= ".concat(MAX_INT32 - 1, ". Received ").concat(value));
  }

  buf.set([value >>> 24, value >>> 16, value >>> 8, value & 0xff], offset);
}

export function uint64be(value) {
  var high = Math.floor(value / MAX_INT32);
  var low = value % MAX_INT32;
  var buf = new Uint8Array(8);
  writeUInt32BE(buf, high, 0);
  writeUInt32BE(buf, low, 4);
  return buf;
}
export function uint32be(value) {
  var buf = new Uint8Array(4);
  writeUInt32BE(buf, value);
  return buf;
}
export function lengthAndInput(input) {
  return concat(uint32be(input.length), input);
}
export function concatKdf(_x, _x2, _x3, _x4) {
  return _concatKdf.apply(this, arguments);
}

function _concatKdf() {
  _concatKdf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(digest, secret, bits, value) {
    var iterations, res, iter, buf;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            iterations = Math.ceil((bits >> 3) / 32);
            iter = 1;

          case 2:
            if (!(iter <= iterations)) {
              _context.next = 22;
              break;
            }

            buf = new Uint8Array(4 + secret.length + value.length);
            buf.set(uint32be(iter));
            buf.set(secret, 4);
            buf.set(value, 4 + secret.length);

            if (res) {
              _context.next = 13;
              break;
            }

            _context.next = 10;
            return digest('sha256', buf);

          case 10:
            res = _context.sent;
            _context.next = 19;
            break;

          case 13:
            _context.t0 = concat;
            _context.t1 = res;
            _context.next = 17;
            return digest('sha256', buf);

          case 17:
            _context.t2 = _context.sent;
            res = (0, _context.t0)(_context.t1, _context.t2);

          case 19:
            iter++;
            _context.next = 2;
            break;

          case 22:
            res = res.slice(0, bits >> 3);
            return _context.abrupt("return", res);

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _concatKdf.apply(this, arguments);
}